<div class=" container-style p-0 mb-3">
  <div class="px-3 py-2 d-flex justify-content-between align-items-center border-bottom">
    <span class="fw-bold"><i class="pi pi-cog me-2"></i>Componentes <p-badge severity="secondary"
        [value]="components.length" /></span>
    <div class="d-flex gap-1">
      <p-button icon="pi pi-trash" [text]="true" size="small" [disabled]="maintenanceRoutineModel.active"
        (onClick)="delete()" />
      <p-button icon="pi pi-plus" [text]="true" size="small" [disabled]="maintenanceRoutineModel.active"
        (onClick)="newComponent()" />
      <app-custom-modal #componentModal [label]="'Componentes'" [width]="'30rem'" [header]="'Componentes'"
        [children]="componentRegisterModal" [inputs$]="inputsForRegister$" [output$]="output$"
        (params)="reloadList($event.reload)" hidden>
      </app-custom-modal>
    </div>
  </div>
  <div class="list-group list-group-flush">
    @for (comp of components; track comp.componentId) {
    <button class="list-group-item list-group-item-action d-flex justify-content-between align-items-center border-0"
      [class.active-item]="selectedComponent.componentId === comp.componentId" (click)="componentSelected(comp)">
      {{ comp.code}} - {{comp.name }}
      <i class="pi pi-chevron-right small"></i>
    </button>
    }
  </div>
</div>